import { defaultIconMapping } from '@/config/iconMapping'

export const customerConfig = {
  images: {
    attachmentBg: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMoAAADKCAQAAABObBcjAAABKklEQVR42u3RMQEAAACCMO1f2hoeIwJrdFctgCIoUAQFiqBAERRBgSIoUAQFiqAIChRBgSIoUARFUKAIChRBgSIoggJFUKAIChRBERQoggJFUKAIiqBAERQoggJFUAQFiqBAERQogiIoUAQFiqBAERRBgSIoUAQFiqAIChRBgSIoUARFUKAIChRBgSIoUCyAIihQBAWKoEARFEGBIihQBAWKoAgKFEGBIihQBEVQoAgKFEGBIiiCAkVQoAgKFEERFCiCAkVQoAiKoEARFCiCAkVQBAWKoEARFCiCIihQBAWKoEARFEGBIihQBAWKoAgKFEGBIihQBEVQoAgKFEGBIihQLIAiKFAEBYqgQBEUQYEiKFAEBYqgCAoUQYEiKFAERVCgCAoUQYGijwb7ZgDLHG6yNwAAAABJRU5ErkJggg==',
    avatarPlaceholder: require('@/assets/pictures/avatar_placeholder.png'),
    bodyBg: require('./assets/images/backgrounds/background.jpg'),
    errorBg: require('./assets/images/backgrounds/error_background.jpg'),
    imagePlaceholder: require('@/assets/pictures/image_placeholder.png'),
    logo: require('./assets/images/logos/logo.svg'),
    overlayBg: require('./assets/images/backgrounds/overlay_background.jpg'),
    scoresPageBg: undefined,
  },
  backButton: 'app',
}

const iconPrefix = 'm1-icon'

const customIconMapping = {
  account: `${iconPrefix}-checked-man`,
  anniversary: `${iconPrefix}-award`,
  arrow_bottom: `${iconPrefix}-arrow-bottom`,
  arrow_left: `${iconPrefix}-arrow-left`,
  arrow_right: `${iconPrefix}-arrow-right`,
  arrow_right_long: `${iconPrefix}-arrow-right-long`,
  attachment: `${iconPrefix}-attachment`,
  back_to_top: `${iconPrefix}-arrow-top`,
  birthday: `${iconPrefix}-ballons`,
  chat_filled: `${iconPrefix}-chat_filled`,
  check: `${iconPrefix}-check`,
  close: `${iconPrefix}-close`,
  comment: `${iconPrefix}-comment`,
  comment_filled: `${iconPrefix}-comment_filled`,
  download: `${iconPrefix}-download`,
  download_circle: `${iconPrefix}-download_circle`,
  dummy: `${iconPrefix}-dummy`,
  emotions: `${iconPrefix}-emotions`,
  file: `${iconPrefix}-file`,
  group: `${iconPrefix}-group`,
  heart: `${iconPrefix}-heart`,
  heart_filled: `${iconPrefix}-heart_filled`,
  info: `${iconPrefix}-info`,
  logout: `${iconPrefix}-logout`,
  mail: `${iconPrefix}-mail`,
  members: `${iconPrefix}-members`,
  minus: `${iconPrefix}-minus`,
  notification: `${iconPrefix}-notification`,
  pen: `${iconPrefix}-pen`,
  plus: `${iconPrefix}-plus`,
  refresh: `${iconPrefix}-refresh`,
  search: `${iconPrefix}-search`,
  settings: `${iconPrefix}-settings`,
  slider_separator: `${iconPrefix}-minus`,
  star: `${iconPrefix}-star`,
  star_filled: `${iconPrefix}-star_filled`,
  star_half: `${iconPrefix}-star_half`,
  submit: `${iconPrefix}-arrow-right-long`,
  subpages_default: `${iconPrefix}-logo`,
  trash: `${iconPrefix}-trash`,
  upload: `${iconPrefix}-upload`,
}
export const iconMapping = icon => { return customIconMapping[icon] || defaultIconMapping[icon] }
